import React from "react";

const Stops = ({ stops, onStopsChange }) => {
  const handleStopChange = (e, idx) => {
    const { name, value } = e.target;
    const updatedStops = [...stops];
    updatedStops[idx] = { ...updatedStops[idx], [name]: value };
    onStopsChange(updatedStops);
  };

  const addStop = () => {
    const newStop = {
      stopNumber: stops.length + 1,
      stopType: "", // dropdown controlled
      // shipment: "",
      // locationERPIdentifier: `LOC100${stops.length + 1}`,
      addressLine1: "123 Example St.",
      addressLine2: `Suite ${stops.length + 1}`,
      city: "San Francisco",
      state: "CA",
      zipCode: `9410${stops.length + 1}`,
      country: "USA",
      countryISO_CODE: "US",
      latitude: 37.7749 + stops.length * 0.01,
      longitude: -122.4194 + stops.length * 0.01,
      scheduledGateIn: new Date().toISOString(),
      scheduledGateOut: new Date(Date.now() + 3600000).toISOString(),
      actualGateIn: new Date().toISOString(),
      actualGateOut: new Date(Date.now() + 5400000).toISOString(),
      predictedGateIn: null,
      predictedGateOut: null,
      createdDate: new Date().toISOString(),
      createdBy: "system",
      updatedDate: new Date().toISOString(),
      updatedBy: "system"
    };
    onStopsChange([...stops, newStop]);
  };

  const removeStop = (idx) => {
    const updatedStops = stops.filter((_, i) => i !== idx);
    onStopsChange(updatedStops.map((s, i) => ({ ...s, stopNumber: i + 1 })));
  };

  return (
    <div className="mt-6">
      <h3 className="text-lg font-bold mb-4">Stops</h3>
      {stops.map((stop, idx) => (
        <div key={idx} className="border rounded p-4 mb-4 bg-gray-50">
          <div className="flex justify-between items-center">
            <h4 className="font-semibold">Stop #{stop.stopNumber}</h4>
            {stops.length > 1 && (
              <button onClick={() => removeStop(idx)} className="bg-red-500 text-white px-3 py-1 rounded">
                Remove
              </button>
            )}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
            <div>
              <label className="block font-medium mb-1">Stop Type</label>
              <select
                name="stopType"
                value={stop.stopType}
                onChange={(e) => handleStopChange(e, idx)}
                className="border rounded p-2 w-full"
              >
                <option value="">-- Select --</option>
                <option value="ORIGIN">ORIGIN</option>
                <option value="DESTINATION">DESTINATION</option>
              </select>
            </div>

            {Object.entries(stop).map(([key, val]) => {
              if (key === "stopNumber" || key === "stopType") return null;
              return (
                <div key={key}>
                  <label className="block font-medium mb-1">{key}</label>
                  <input
                    type={key.toLowerCase().includes("date") || key.toLowerCase().includes("time") ? "datetime-local" : typeof val === "number" ? "number" : "text"}
                    name={key}
                    value={val || ""}
                    onChange={(e) => handleStopChange(e, idx)}
                    className="border rounded p-2 w-full"
                  />
                </div>
              );
            })}
          </div>
        </div>
      ))}
      <button onClick={addStop} className="bg-blue-500 text-white px-4 py-2 rounded">
        + Add Stop
      </button>
    </div>
  );
};

export default Stops;
